import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../../Shared.js';
import { numberSchema } from '../schemas.js';

const lineItemSchema = z.object({
  kind: z.literal("line"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  reverseLineDirection: z.boolean(),
  settings: z.object({
    movable: z.boolean().default(false),
    cloneable: z.boolean().default(false)
  }).nullish().default({ cloneable: false, movable: false }),
  style: z.object({
    stroke: z.object({
      color: z.string(),
      width: numberSchema(1)
    })
  }).nullish().default({ stroke: { color: "#000", width: 1 } })
});

export { lineItemSchema };
//# sourceMappingURL=Line.js.map
